import { render, staticRenderFns } from "./personnelInfo.vue?vue&type=template&id=0e980091&scoped=true&"
import script from "./personnelInfo.vue?vue&type=script&lang=js&"
export * from "./personnelInfo.vue?vue&type=script&lang=js&"
import style0 from "./personnelInfo.vue?vue&type=style&index=0&id=0e980091&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e980091",
  null
  
)

export default component.exports